import * as React from "react"

const Grid = ({ children, className }) => (
  <div className={`tw-grid tw-grid-cols-12 ${className}`}>{children}</div>
)

export default Grid